// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"cf86fc40","215":"7a9423ca","339":"d2589606","440":"57022297","453":"679891a4","476":"8dc67c22","518":"1a5216ad","560":"65fbd852","568":"e51691fa","918":"8bee3d47","928":"3b4ec358"}[chunkId] + ".chunk.js";
};